'use client'
import { useEffect, ReactNode } from 'react'
import { useWikiContext } from '@/context/wikiContext'

// Breadcrumbs Injector
export function WikiLayoutInjector({
  breadcrumbs,
  onPageNav,
}: {
  breadcrumbs: ReactNode
  onPageNav: ReactNode
}) {
  const { setBreadcrumbs, setOnPageNav } = useWikiContext()

  useEffect(() => {
    setBreadcrumbs(breadcrumbs)
    setOnPageNav(onPageNav)
    console.log('set breadcrumbs and opnav', breadcrumbs, onPageNav)
  }, [])

  return <div></div>
}
